import api from "api";
import { useCallback, useEffect, useRef, useState } from "react";
import 'styles/quoteprice.css';

// affiche le coût d'une catégorie
const QuotePriceItem = (
    {
        quoteid,
        groupid,
        subCategoryid,
        coeff,
        groups,
        dataToReload
    }
) => {

    const [ items, setItems ] = useState([]);

    // récupère les données
    useEffect(()=>{
        api.get(`quote/${quoteid}/price/group/${groupid}/subcategory/${subCategoryid}/coeff/${coeff}`)
        .then((response)=>{
            setItems(response.data);
        });
    },[quoteid,groupid,subCategoryid,coeff,groups,dataToReload]);

    return (
        items.length > 0
        &&
        items.map((item) => 
            <>
                <div
                    className="QuotePriceLabel QuotePriceLabelItem QuotePriceOdd"
                >
                    { item.name }
                </div>
                <div
                    className='QuotePricePrice QuotePriceOdd'
                >
                    { item.price.toFixed(2) } €
                </div>
                <div
                    className="QuotePriceOdd"
                ></div>
            </>
        )
    )

};

// affiche le coût d'une sous catégorie
const QuotePriceSubCategoryLine = (
    {
        subCategory,
        quoteid,
        groupid,
        categoryid,
        coeff,
        groups,
        dataToReload        
    }
) => {

    const [ showItem, setShowItem ] = useState(false);

    // traite de déroulement des catégories
    const handleClick = () => {
        setShowItem(!showItem);
    };

    return(
        <>
            <div
                className="QuotePriceLabel QuotePriceLabelSubCategory QuotePriceOdd"
                onClick={handleClick}
            >
                { subCategory.name }
            </div>
            <div
                className='QuotePricePrice QuotePriceOdd'
            >
                { !showItem && `${subCategory.price.toFixed(2)} €` }
            </div>
            <div
                className="QuotePriceOdd"
            ></div>
            {
                showItem
                &&
                <>
                    <QuotePriceItem
                        key={`${groupid}-${categoryid}-${subCategory.id}`}
                        quoteid={quoteid}
                        groupid={groupid}
                        subCategoryid={subCategory.id}
                        coeff={coeff}
                        groups={groups}
                        dataToReload={dataToReload}
                    />
                    <div
                        className="QuotePriceSubTotal QuotePriceOdd"
                    >
                        Sous-total { subCategory.name }
                    </div>
                    <div
                        className='QuotePricePrice QuotePriceSubTotal QuotePriceOdd'
                    >
                        {`${subCategory.price.toFixed(2)} €` }
                    </div>
                    <div
                        className="QuotePriceOdd"
                    ></div>
                </>
            }
        </>
    );
};

// affiche le coût des sous-catégories d'une catégorie d'un groupe ou du devis si group = 0
const QuotePriceSubCategory = (
    {
        quoteid,
        groupid,
        categoryid,
        coeff,
        groups,
        dataToReload
    }
) => {

    const [ subCategories, setSubCategories ] = useState([]);

    // récupère les données
    useEffect(()=>{
        api.get(`quote/${quoteid}/price/group/${groupid}/category/${categoryid}/subcategories/coeff/${coeff}`)
        .then((response)=>{
            setSubCategories(response.data);
        });
    },[quoteid, groupid, categoryid, coeff, groups, dataToReload]);
    
    return (
        subCategories.length > 0
        &&
        subCategories.map((subCategory) => <QuotePriceSubCategoryLine
            key={subCategory.id}
            subCategory={subCategory}
            quoteid={quoteid}
            groupid={groupid}
            categoryid={categoryid}
            coeff={coeff}
            groups={groups}
            dataToReload={dataToReload}
        />
        )
    )
};

// affiche de coût d'une catégorie
const QuotePriceCategoryLine = (
    {
        quoteid,
        groupid,
        coeff,
        groups,
        category,
        dataToReload
    }
) => {

    const [ showSubCategory, setShowSubCategory ] = useState(false);

    // traite de déroulement des catégories
    const handleClick = () => {
        setShowSubCategory(!showSubCategory);
    };

    return(
        <>
            <div
                className="QuotePriceLabel QuotePriceLabelCategory QuotePriceOdd"
                onClick={handleClick}
            >
                { category.name }
            </div>
            <div
                className='QuotePricePrice QuotePriceOdd'
            >
                { !showSubCategory && `${category.price.toFixed(2)}  €` }
            </div>
            <div
                className="QuotePriceOdd"
            ></div>
            {
                showSubCategory
                &&
                <>
                    <QuotePriceSubCategory
                        key={`${groupid}-${category.id}`}
                        quoteid={quoteid}
                        groupid={groupid}
                        categoryid={category.id}
                        coeff={coeff}
                        groups={groups}
                        dataToReload={dataToReload}
                    />
                    <div
                        className="QuotePriceSubTotal QuotePriceOdd"
                    >
                        Sous-total { category.name }
                    </div>
                    <div
                        className='QuotePricePrice QuotePriceSubTotal QuotePriceOdd'
                    >
                        {`${category.price.toFixed(2)} €` }
                    </div>
                    <div
                        className="QuotePriceOdd"
                    ></div>
                </>   
            }
        </>
    );
};

// affiche le coût des catégories d'un groupe ou du devis si group = 0
const QuotePriceCategory = (
    {
        quoteid,
        groupid,
        coeff,
        groups,
        dataToReload
    }
) => {

    const [ categories, setCategories ] = useState([]);

    // récupère les données
    useEffect(()=>{
        api.get(`quote/${quoteid}/price/group/${groupid}/categories/coeff/${coeff}`)
        .then((response)=>{
            setCategories(response.data);
        });
    },[quoteid, groupid, coeff, groups,dataToReload]);

    return (
        categories.length > 0
        &&
        categories.map((category) => <QuotePriceCategoryLine
            key={category.id}
            category={category}
            quoteid={quoteid}
            groupid={groupid}
            coeff={coeff}
            groups={groups}
            dataToReload={dataToReload}
        />
        )
    )
};

// affiche le coût d'un groupe
const QuotePriceGroupLine = (
    {
        group,
        quoteid,
        coeff,
        groups,
        dataToReload,
        setSumEdit,
        enter,
        setEnter,
        ratio,
    }
) => {

    const [ priceEdit, setPriceEdit ] = useState(false);
    const [ showCategory, setShowCategory ] = useState(false);
    const inputRef = useRef(null);
    const [ value, setValue ] = useState("");
    const [ price, setPrice ] = useState(null);
    
    useEffect(()=>{
        if (group.user_price) {
             setPrice(parseFloat(group.user_price));
        }
     },[group.user_price]);

    useEffect(()=>{
        if (ratio) setPrice(group.price*ratio);
    },[ratio,group.price]);

    useEffect(()=>{
        if (priceEdit && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    },[priceEdit]);
    
    // traite de déroulement des catégories
    const handleClick = () => {
        setShowCategory(!showCategory);
    };

    const handleChangeValue = (e) => {
        const newValue = e.target.value;
        const regex = /^\d*(\.\d{0,2})?$/;
        if (newValue === "") setValue("");
        else if (regex.test(newValue)) setValue(newValue);
    };
 
    const handlePriceClick = () => {
        if (priceEdit) setPriceEdit(false);
        else {
            setSumEdit(false);
            setPriceEdit(true);
        }
    };

    useEffect(()=>{
        if (enter) {
            setEnter(false);
            if (priceEdit) {
                setPriceEdit(false);
                if (parseFloat(value)!==parseFloat(price)) {
                    api.put(`group/${group.id}/price`, { user_price : value==="" ? null : parseFloat(value) }); 
                }
            }
        }
    },[enter, group.id, price, priceEdit,setEnter,value]);
    
    return(
        <>
            <div
                className="QuotePriceLabel QuotePriceLabelGroup QuotePriceOdd"
                onClick={handleClick}
            >
                { group.name }
            </div>
            <div
                className='QuotePricePrice QuotePriceOdd QuotePriceGroup'
                onClick={handlePriceClick}
            >
                { !showCategory && `${group.price.toFixed(2)} €` }
            </div>
            <div
                className="QuotePricePrice QuotePriceOdd"
            >
                 {
                        priceEdit
                        ?
                        <input
                            type="text"
                            value={value}
                            onChange={handleChangeValue}
                            ref={inputRef}
                        />
                        :
                        (
                            price
                            &&
                            <span
                                className="QuotePriceMyPrice"
                            >
                                { price.toFixed(2)} €
                            </span>
                        )
                    }
            </div>
            {
                showCategory
                &&
                <> 
                    <QuotePriceCategory
                        key={group.id}
                        quoteid={quoteid}
                        groupid={group.id}
                        coeff={coeff}
                        groups={groups}
                        dataToReload={dataToReload}
                    />
                    <div
                        className="QuotePriceSubTotal QuotePriceOdd"
                    >
                        Sous-total { group.name }
                    </div>
                    <div
                        className='QuotePricePrice QuotePriceSubTotal QuotePriceOdd'
                    >
                        {`${group.price.toFixed(2)} €` }
                    </div>
                    <div
                        className="QuotePriceOdd"
                    >
                    </div>
                </>
            }
        </>
    )
};

// affiche le coût des groupes
const QuotePriceGroup = (
    {
        quoteid,
        coeff,
        groups,
        dataToReload,
        setSumEdit, 
        enter,
        setEnter,
        recalculatePriceQuote,
        ratio,
        setRatio
    }
) => {

    const [ prices, setPrices ] = useState([]);

    // récupère les données
    useEffect(()=>{
        api.get(`quote/${quoteid}/price/groups/coeff/${coeff}`)
        .then((response)=>{
            setPrices(response.data);
            const totalPrice = response.data.reduce((sum, group) => {
                return sum + parseFloat(group.user_price ?? 0);
            }, 0.0);
            if (totalPrice!==0.0) {
                recalculatePriceQuote(totalPrice);
            }
        });
    }, [quoteid, coeff, recalculatePriceQuote]);
    
    return (
            prices.length > 0
            &&
            prices.map((group) => <QuotePriceGroupLine
                key={group.id}
                group={group}
                quoteid={quoteid}
                coeff={coeff}
                groups={groups}
                dataToReload={dataToReload}
                setSumEdit={setSumEdit}
                enter={enter}
                setEnter={setEnter}
                ratio={ratio}
            />
            )
    )
};

const QuotePrice = (
    {
        quoteid,
        groups,
        coeff,
        dataToReload,
        enter,
        setEnter,
        quotePrice,
    }
) => {

    const [ price, setPrice ] = useState(0.0); // calcul du prix du devis
    const [ myPrice, setMyPrice ] = useState(null); // prix du devis modifié par l'utilisateur
    const [ HTEdit, setHTEdit ] = useState(false);
    const [ TTCEdit, setTTCEdit ] = useState(false);
    const [ HTValue, setHTValue ] = useState(null);
    const [ TTCValue, setTTCValue ] = useState(null);
    const [ sumEdit, setSumEdit ] = useState(false);
    const HTinput = useRef(null);
    const TTCinput = useRef(null);
    const [ ratio, setRatio ] = useState(null);

    useEffect(()=>{
        if (quotePrice) {
             setMyPrice(parseFloat(quotePrice));
        }
     },[quotePrice]);

    useEffect(()=>{
        if (coeff) {
            api.get(`quote/${quoteid}/price/coeff/${coeff}`)
            .then((response) => {
                if (response.data.price) setPrice(parseFloat(response.data.price));
            });
        }
    },[quoteid,coeff,groups,dataToReload]);
    
    useEffect(()=>{
        if (!sumEdit) {
            setHTEdit(false);
            setTTCEdit(false);
        }
    },[sumEdit,setHTEdit, setTTCEdit]);
    
    const handleChangeHT = () => {
        if (HTEdit) setSumEdit(false);
        else
        {
            setHTValue(myPrice ? myPrice.toFixed(2) : price);
            setHTEdit(true);
            setTTCEdit(false);
            setSumEdit(true);
        }   
    };

    useEffect(() => {
        if (HTEdit && HTinput.current) {
            HTinput.current.focus();
            HTinput.current.select();
        }
    }, [HTEdit]);
    
    const handleChangeHTValue = (e) => {
        const value = e.target.value;
        const regex = /^\d*(\.\d{0,2})?$/;
        if (value === "") setHTValue("");
        else if (regex.test(value)) setHTValue(value);
    };

    const handleChangeTTC = () => {
        if (TTCEdit) setSumEdit(false);
        else
        {
            setTTCValue(myPrice ? (myPrice*1.2).toFixed(2) : price*1.2);
            setTTCEdit(true);
            setHTEdit(false);
            setSumEdit(true);
        }   
    };

    useEffect(() => {
        if (TTCEdit && TTCinput.current) {
            TTCinput.current.focus();
            TTCinput.current.select();
        }
    }, [TTCEdit]);
    
    const handleChangeTTCValue = (e) => {
        const value = e.target.value;
        const regex = /^\d*(\.\d{0,2})?$/;
        if (value === "") setTTCValue("");
        else if (regex.test(value)) setTTCValue(value);
    };
    
    useEffect(()=>{
        if (enter) {
            setEnter(false);
            if (HTEdit) {
                setHTEdit(false);
                if (parseFloat(HTValue)!==parseFloat(price)) {
                    api.put(`quote/${quoteid}/price`, { user_price : HTValue==="" ? null :  parseFloat(HTValue)});
                }
                setMyPrice(parseFloat(HTValue));
            }
            if (TTCEdit) {
                setTTCEdit(false);
                if (parseFloat(TTCValue)!==parseFloat(price*1.2)) {
                    api.put(`quote/${quoteid}/price`, { user_price : TTCValue==="" ? null : parseFloat((TTCValue/1.2).toFixed(2)) });                    
                }
                setMyPrice(parseFloat(TTCValue/1.2));
            }
        }
        
    },[enter, HTEdit, HTValue, price, setEnter, TTCEdit, TTCValue, quoteid]);
     
    const recalculatePriceQuote = useCallback((total) => {
        setRatio(null);
        setMyPrice( (myPrice ? myPrice : price) - total );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    return (
        coeff
        &&
        <div
            id="QuotePrice"
        >
            <div
                id='QuotePriceTitle'
            >
                PRIX
            </div>
            {
                groups.length > 0
                &&
                <QuotePriceGroup
                    quoteid={quoteid}
                    coeff={coeff}
                    groups={groups}
                    dataToReload={dataToReload}
                    setSumEdit={setSumEdit}
                    enter={enter}
                    setEnter={setEnter}
                    recalculatePriceQuote={recalculatePriceQuote}
                    ratio={ratio}
                    setRatio={setRatio}
                />
            }
            {

                groups.length === 0
                &&
                <QuotePriceCategory
                    quoteid={quoteid}
                    groupid={0}
                    coeff={coeff}
                    groups={groups}
                    dataToReload={dataToReload}
                />
            }
            {
                <>
                    <div
                        className="QuotePriceTotal"
                    >
                        TOTAL HT
                    </div>
                    <div
                        className="QuotePricePrice"
                        id="QuotePriceHT"
                        onClick={handleChangeHT}
                    >
                        { `${price.toFixed(2)} €`}
                    </div>
                    <div
                        className="QuotePricePrice"
                    >
                        {
                            HTEdit
                            ?
                            <input
                                type="text"
                                value={HTValue}
                                onChange={handleChangeHTValue}
                                ref={HTinput}
                            />
                            :
                            (
                                myPrice
                                &&
                                <span
                                    className="QuotePriceMyPrice"
                                >
                                    { myPrice.toFixed(2)} €
                                </span>
                            )
                        }
                    </div>
                    <div
                       className="QuotePriceTVA"
                    >
                        TVA 20 %
                    </div>
                    <div
                        className="QuotePricePrice"
                    >
                        { `${(price*.2).toFixed(2)} €`}
                    </div>
                    <div
                        className="QuotePricePrice"
                    >
                        {
                            myPrice
                            &&
                            <span
                                className="QuotePriceMyPrice"
                            >
                                { (myPrice*.2).toFixed(2)} €
                            </span>
                        }
                    </div>
                    <div
                        className="QuotePriceTotal"
                    >
                        TOTAL TTC
                    </div>
                    <div
                        className="QuotePricePrice"
                        id="QuotePriceTTC"
                        onClick={handleChangeTTC}
                    >
                        { `${(price*1.2).toFixed(2)} €`}
                    </div>
                    <div
                        className="QuotePricePrice"
                    >
                        {
                            TTCEdit
                            ?
                            <input
                                type="text"
                                value={TTCValue}
                                onChange={handleChangeTTCValue}
                                ref={TTCinput}
                            />
                            :
                            (
                                myPrice
                                &&
                                <span
                                    className="QuotePriceMyPrice"
                                >
                                    { (myPrice*1.2).toFixed(2)} €
                                </span>
                            )
                        }
                    </div>
                </>
            }
        </div>
    );
};

export default QuotePrice;